export const syncPropertiesTranslations = {
  "user-settings": "Uživatelská nastavení",
  "alcohol-data": "Záznamník",
  "own-items": "Vlastní nápoje a nádoby",
} as const;
